import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: BASE });

export const adminApi = axios.create({ baseURL: BASE });
adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("fs_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const getConfig = () => api.get("/config").then((r) => r.data);
export const createSession = () => api.post("/session").then((r) => r.data);
export const runQualityGate = (session_id, images) =>
  api.post("/quality-gate", { session_id, images }).then((r) => r.data);
export const runAnalyze = (session_id, images) =>
  api.post("/analyze", { session_id, images }).then((r) => r.data);
export const submitQuestionnaire = (session_id, answers) =>
  api.post("/questionnaire", { session_id, answers }).then((r) => r.data);
export const trackEvent = (session_id, event) =>
  api.post("/event", { session_id, event }).catch(() => {});
